import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#25D5B2', // Teal/Aquamarine from the site
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#414141', // Dark Charcoal for backgrounds/text
        },
        background: {
            default: '#ffffff',
            paper: '#ffffff',
            light: '#F3F3F3', // Light Grey for section backgrounds
        },
        text: {
            primary: '#333333',
            secondary: '#666666',
        },
    },
    typography: {
        fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
        },
        h2: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        button: {
            textTransform: 'none', // Buttons on the site often have normal casing
            fontWeight: 600,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '4px', // Slight rounding
                    padding: '10px 24px',
                },
            },
        },
        MuiContainer: {
            defaultProps: {
                maxWidth: 'lg',
            },
        },
    },
});

export default theme;
